import { LitElement, css, html } from 'lit'
import { customElement, property, query } from 'lit/decorators.js'

import mapImg from './assets/map.svg'
import { MarkerModel } from './models/marker';
import { repeat } from 'lit/directives/repeat.js';


/**
 * An example element.
 *
 * @slot - This element has a slot
 * @csspart button - The button
 */
@customElement('dm-mapview')
export class MapViewElement extends LitElement {

	@property({type:Object})
	markers: MarkerModel[] = [];


	@property({ type: Boolean })
	editMode: boolean = false;

	@query('#mapimg')
	_mapImg!: HTMLImageElement;

	private getMarkerPointerEvent() :string{
		return (this.editMode) ? "none" : "auto"
	}



	private _onMapClick(event: PointerEvent) {

		let marker = new MarkerModel();
			marker.x = (event.offsetX / this._mapImg.offsetWidth) * 100;
			marker.y = (event.offsetY / this._mapImg.offsetHeight) * 100;

		let customevt = new CustomEvent('map-click', {
			detail:{
				marker: marker
			}
			
		});
		this.dispatchEvent(customevt);
	}

	private _mouseOverMarker(marker: MarkerModel) {
		for (var i = 0; i < this.markers.length; i++) {
			if (this.markers[i]) {
				this.markers[i].active = false;
			}
		}

		marker.active = true;
		this.requestUpdate();

		let customevt = new CustomEvent('marker-over', {
			detail: {
				marker: marker
			}

		});
		this.dispatchEvent(customevt);
	}

	private _mouseOutMarker(marker: MarkerModel) {
		//for (var i = 0; i < this.markers.length; i++) {
		//	this.markers[i].active = false;
		//}

		
		//this.requestUpdate();

		let customevt = new CustomEvent('marker-out', {
			detail: {
				marker: marker
			}

		});
		this.dispatchEvent(customevt);
	}



	render() {


		return html`

		<div class="map-container">
		<div class="img-container">
<div style="height:100%;float:right;position:relative" @click="${this._onMapClick}">
		 <img id="mapimg" src=${mapImg} class="map-image" alt="Map of locations" />
		
 		${repeat(this.markers, (marker) => marker, (marker) =>
				html`

		
			<a class="marker ${(marker?.active ? "active" : "")}" style="left:calc(${marker?.x}% - 10px);top:calc(${marker?.y}% - 10px);pointer-events:${this.getMarkerPointerEvent()}" @mouseover="${() => { this._mouseOverMarker(marker) }}" @mouseout="${() => { this._mouseOutMarker(marker) }}" href="${marker?.url}">
			<div class="title-container">
			<div class="title">${marker?.title}<br/>${marker?.suburb}</div>
			</div>
			
			</div>`)}

		  </div>
  <slot></slot>
		  </div>
		</div>

      <div>
      
      </div>
     
    `
	}



	static styles = css`
    :host {

    }

.marker{
width: 12px;
height:12px;
/*border-radius:100%;
background-color: 	#243746;*/
position: absolute;
z-index:1;
background-image: url('/images/masterpage/helm_h_reversed.svg');
background-size: 80%;
background-repeat: no-repeat;
background-position: center;
transition: 0.2s all ease-in-out;
text-decoration:none;
}

.marker.active{
/*background-color: #CE3438;*/
z-index:100;
background-size: 100%

}

		.map-container{
height: calc(100vh - 200px) ;
max-height: calc(100vh - 220px) ;

	}
	.img-container{
		overflow: hidden;
		height: 100%;
		width:100%;
	}

	@media(min-width:768px){
		.map-container{

		}
	}

	@media(min-width:1300px){
		.map-container{

		}
	}



	.map-container .map-image{
		display:block;
		min-height: 100%;
		float:right;
	}


   .title-container{
	   width: 200px;
	   height: 40px;
	   transform:translateX(-97px)  translateY(-20px);
	   display:flex;
	   justify-content:center;
	   align-items:flex-end;
	   pointer-events: none;
	   opacity:0;
	   transition:0.3s all ease-in-out;
   }

   .active .title-container{
	   z-index:100;
	   pointer-events: auto !important;
	   }

   .title-container:after{
	   content: '';
	   display:block;
	   width:20px;
	   height:20px;
	   background-color: #243746;
	   left: calc(50% - 7px);
    position: absolute;
    transform: rotate(45deg);
    bottom: -4px;
    z-index: -1;
   }

   .title{
	   background-color: #243746;
	   border-radius:4px;
	   color:#FFF;
	   padding:4px 15px;
	   font-family:"Lora", serif;
	   text-align:center;
	   
   }

   .marker.active .title-container{
	    opacity:1;
		transform:translateX(-97px)  translateY(-50px);
		
   }
  `
}

declare global {
	interface HTMLElementTagNameMap {
		'dm-mapview': MapViewElement
	}
}
